module.exports = __webpack_public_path__ + "img/Villa_Borna_39.aaaa12e1.jpg";